export default __webpack_public_path__ + "static/media/player_6.9ac0f2fd.mp3";